import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/media.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

